if (!customElements.get('jm-vitrine-card')) {
    customElements.define('jm-vitrine-card', class extends HTMLElement {
      connectedCallback() {
        if (this._jmInit) return;
        // Em 2ª+ instância o elemento já está definido, então o callback pode
        // rodar ANTES dos filhos serem parseados. Se o conteúdo ainda não existe,
        // esperamos o DOM terminar e reinicializamos.
        if (!this.querySelector('.jm-vitrine-card__info')) {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        this._jmInit = true;

        this.images = [...this.querySelectorAll('[data-gallery-image]')];

        // hover-peek integrado às setas: ao passar o mouse mostra a 2ª foto;
        // a seta continua A PARTIR do que está visível (sem conflito); ao sair
        // sem clicar, volta pra 1ª. Navegou manualmente? O peek se desativa.
        if (this.images.length > 1 && window.matchMedia('(hover: hover)').matches) {
          // pré-aquece a foto do peek em idle, pro hover ser instantâneo
          const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 600));
          idle(() => {
            const second = this.images[1];
            if (second && second.getAttribute('loading') === 'lazy') second.setAttribute('loading', 'eager');
          });

          this.addEventListener('mouseenter', () => {
            if (this._jmManual) return;
            if (Number(this.dataset.galleryIndex || 0) === 0) {
              this._jmPeek = true;
              this.classList.add('is-peeking');
              this.dataset.galleryIndex = '1';
              this.updateImages();
            }
          });
          this.addEventListener('mouseleave', () => {
            this.classList.remove('is-peeking');
            if (this._jmPeek && !this._jmManual) {
              this._jmPeek = false;
              this.dataset.galleryIndex = '0';
              this.updateImages();
            }
          });
        }
        this.sizeButtons = [...this.querySelectorAll('[data-jm-size]')];
        this.variantInput = this.querySelector('[data-jm-variant-input]');
        this.addButton = this.querySelector('.jm-vitrine-card__add');

        this.querySelector('[data-jm-gallery-prev]')?.addEventListener('click', () => this.changeImage(-1));
        this.querySelector('[data-jm-gallery-next]')?.addEventListener('click', () => this.changeImage(1));
        this.sizeButtons.forEach((button) => button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.selectSize(button);
        }));
        if (this.sizeButtons.length && this.addButton) this.addButton.disabled = true;

        this.addButton?.addEventListener('click', (event) => {
          event.preventDefault();
          this.addToCart();
        });

        const wishlist = this.querySelector('[data-jm-wishlist]');
        if (wishlist) {
          const syncHeart = () => {
            const on = window.JMWishlist ? window.JMWishlist.has(this.dataset.productHandle) : false;
            wishlist.classList.toggle('is-active', on);
            wishlist.setAttribute('aria-pressed', String(on));
          };
          syncHeart();
          wishlist.addEventListener('click', () => this.toggleWishlist(wishlist));
          document.addEventListener('jm:wishlist:change', syncHeart);
        }
        this.updateImages();
        this.classList.add('jm-ready');
      }

      changeImage(direction) {
        if (this.images.length < 2) return;
        this._jmManual = true;
        this._jmPeek = false;
        this.classList.remove('is-peeking');
        const current = Number(this.dataset.galleryIndex || 0);
        const next = (current + direction + this.images.length) % this.images.length;
        const target = this.images[next];
        if (target && target.getAttribute('loading') === 'lazy') target.setAttribute('loading', 'eager');
        this.dataset.galleryIndex = String(next);
        this.updateImages();
      }

      updateImages() {
        const current = Number(this.dataset.galleryIndex || 0);
        this.images.forEach((image, index) => image.classList.toggle('is-active', index === current));
      }

      selectSize(button) {
        const variantId = button.dataset.variantId;
        const wasSelected =
          this.dataset.selectedVariant === variantId ||
          button.getAttribute('aria-pressed') === 'true';

        this.sizeButtons.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

        if (wasSelected) {
          delete this.dataset.selectedVariant;
          this.classList.remove('is-selected');
          this.variantInput.value = '';
          this.variantInput.disabled = true;
          if (this.addButton) this.addButton.disabled = true;
          return;
        }

        this.dataset.selectedVariant = variantId;
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        this.classList.add('is-selected');
        this.variantInput.value = variantId;
        this.variantInput.disabled = false;
        if (this.addButton) this.addButton.disabled = false;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      async addToCart() {
        const button = this.addButton;
        if (!button || button.disabled) return;
        const variantId = this.variantInput?.value;
        if (!variantId) return;

        const label = button.dataset.label || button.textContent.trim();
        button.disabled = true;
        button.textContent = 'Adicionando...';

        try {
          // add + já pede a section do drawer no mesmo request (evita GET extra)
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: 'cart-drawer-section',
              sections_url: '/',
            }),
          });
          if (!res.ok) throw new Error('add-failed');
          const added = await res.json();

          const cart = await fetch('/cart.js').then((r) => r.json());
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
          });

          // avisa os componentes nativos (cart drawer etc.) que o carrinho mudou
          try {
            const { CartLinesUpdateEvent } = await import('@shopify/events');
            const deferred = CartLinesUpdateEvent.createPromise();
            document.dispatchEvent(
              new CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'jm-vitrine-card',
                productId: this.dataset.productId,
                itemCount: 1,
                didError: false,
                sections: added.sections,
              },
            });
          } catch (e) {
            /* módulo indisponível: seguimos só com o contador */
          }

          button.textContent = 'Adicionado ✓';
          window.setTimeout(() => {
            button.textContent = label;
            button.disabled = false;
          }, 1600);
        } catch (error) {
          button.textContent = 'Indisponível';
          window.setTimeout(() => {
            button.textContent = label;
            button.disabled = false;
          }, 1800);
        }
      }

      toggleWishlist(button) {
        if (!window.JMWishlist) return;
        const on = window.JMWishlist.toggle(this.dataset.productHandle);
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', String(on));
      }
    });
  }

  if (!customElements.get('jm-product-showcase')) {
    customElements.define('jm-product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-jm-showcase-track]');
        this.previous = this.querySelector('[data-jm-showcase-prev]');
        this.next = this.querySelector('[data-jm-showcase-next]');
        this.progress = this.querySelector('[data-jm-progress]');
        this.previous.addEventListener('click', () => this.scroll(-1));
        this.next.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.onResize = () => this.update();
        window.addEventListener('resize', this.onResize, { passive: true });
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      scroll(direction) {
        const card = this.track.querySelector('jm-vitrine-card');
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const overflow = max > 2;
        this.previous.hidden = !overflow;
        this.next.hidden = !overflow;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        if (this.progress) {
          const visible = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
          const travelled = max ? this.track.scrollLeft / max : 0;
          const width = Math.max(18, visible * 100);
          this.progress.style.width = `${width}%`;
          this.progress.style.left = `${travelled * (100 - width)}%`;
        }
      }
    });
  }
